export default {
  'TICKET' (state) {
    return state.ticket
  },
  'TICKETS' (state) {
    return state.tickets
  }
}
